module.exports = __webpack_public_path__ + "img/guaranteeIcon3.53c0bc78.png";